export interface IDexeroCoreDefaults {
  accentMap: IDCA.IGenericObj;
  baseURL: string;
  datepickerLang: {
    [locale: string]: {
      dayNames: string[];
      dayNamesShort: string[];
      dayNamesMin: string[];
      monthNames: string[];
      monthNamesShort: string[];
      shortYearCutoff: number;
    };
  };
  defaultURL: string;
  phoneMask: string;
  sessionTimeout: number | false;
  showToastCloseButton: boolean;
  toastPosition: string;
}

export const defaultOptions = {
  actionBaseUrl: '',
  applicationIdentifier: '',
  baseURL: '',
  defaultURL: '',
  lang: '',
  ownerIdentifier: '',
  sessionUser: '',
  username: '',
};

export const dexeroCoreDefaults: IDexeroCoreDefaults = {
  accentMap: {
    À: 'a',
    Â: 'a',
    Ä: 'a',
    Ç: 'c',
    È: 'e',
    É: 'e',
    Ê: 'e',
    Ë: 'e',
    Î: 'i',
    Ï: 'i',
    Ô: 'o',
    Ù: 'u',
    Û: 'u',
    Ü: 'u',
    à: 'a',
    â: 'a',
    ä: 'a',
    ç: 'c',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    î: 'i',
    ï: 'i',
    ô: 'o',
    ù: 'u',
    û: 'u',
    ü: 'u',
    ÿ: 'y',
    Œ: 'o',
    œ: 'o',
    Ÿ: 'y',
  },
  baseURL: '',
  datepickerLang: {
    en: {
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      monthNamesShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      shortYearCutoff: 10,
    },
    fr: {
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
      monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      monthNamesShort: [
        'Janv.',
        'Févr.',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juil.',
        'Août',
        'Sept.',
        'Oct.',
        'Nov.',
        'Déc.',
      ],
      shortYearCutoff: 10,
    },
  },
  defaultURL: '',
  phoneMask: '000-000-0000',
  sessionTimeout: false,
  showToastCloseButton: true,
  toastPosition: 'toast-top-right',
};
